import React from 'react'
import { $Icon, $IconPath } from './styles'

interface Icon {
  (props: {
    width?: number,
    height?: number,
  }): JSX.Element,
}

export const $EnvelopeIcon: Icon = (props) => {
  return (
    <$Icon
      $width={props.width}
      $height={props.height}
    >
      <$IconPath
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        d='M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75'
      />
    </$Icon>
  )
}

export const $ActivateIcon: Icon = (props) => {
  return (
    <$Icon
      $width={props.width}
      $height={props.height}
    >
      <$IconPath
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </$Icon>
  )
}
